import React from 'react';
import PropTypes from 'prop-types';

export default function LocalizedDate(props) {
  const { formatType, timestamp } = props;

  return (
    <span
      className="js-localized-datetime"
      notranslate="true"
      data-behavior="localized-datetime"
      data-format-type={formatType}
      data-timestamp={timestamp}
    >
      {timestamp}
    </span>
  );
}

LocalizedDate.defaultProps = {};

LocalizedDate.propTypes = {
  formatType: PropTypes.string.isRequired,
  timestamp: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/toolkit/localized_date.jsx